import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../utils/utility';

@Pipe({
  name: 'dhm'
})
export class DayHourMinutesPipe implements PipeTransform {

  transform(value: any): string {
    let x = Utility.parseSecondsToDHMS(value);

    return (x.days > 9 ? x.days : `0${x.days}`.slice(-2)) + '-' + (x.hours > 9 ? x.hours : `0${x.hours}`.slice(-2)) + ':' + ((x.minutes) > 9 ? x.minutes : `0${x.minutes}`.slice(-2));
  }

}
